export default [
    {
        path: '/rde-category/list',
        name: 'rde_category_list',
        component: () => import('@src/rde-category/rde-category-list'),
        meta: {
            title: 'RDE-Kategorien',
            role: 'ROLE_RDE_CATEGORY',
        },
    },
    {
        path: '/rde-category/:id?/:tab?',
        name: 'rde_category',
        component: () => import('@src/rde-category/rde-category'),
        props(route) {
            return { id: route.params.id ? Number.parseInt(route.params.id) : null };
        },
        meta: {
            title: 'RDE-Kategorie bearbeiten',
            role: 'ROLE_RDE_CATEGORY',
        },
    },
];
